export * from './visit-admissions-barcode-result.component';
